import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import MaterialTable from "material-table";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  DeleteWorkLocationAction,
} from "../../../../../store/Ancillary/WorkLocation/Action";
import Popup from "../../../Base/views/Popup";
import WorkGeoLocationConfig from "./WorkGeoLocationConfig";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";

const WorkLocation = () => {
  const dispatch = useDispatch();
  const { workLocation_options, isLoading } = useSelector(
    (state) => state?.AncillaryReducer?.WorkLocationReducer
  );

  const structureData = (workLocation_options || [])?.map((item) => ({
    ...item,
    state_id: {
      state_id: item?.state_id,
      state_name: item?.state_name,
    },
    professional_tax_region_id: {
      professional_tax_region_id: item?.professional_tax_region_pk,
      region_name: item?.region_name,
    },
  }));
  const [editedRecord, setEditedRecord] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  return (
    <Box>
      <MaterialTable
        isLoading={isLoading}
        columns={[
          {
            title: "Work Location Name",
            cellStyle: { padding: "0px 10px" },
            field: "work_location_name",
          },
          {
            title: "State",
            headerStyle: { textAlign: "start", paddingLeft: "2%" },
            cellStyle: { textAlign: "start", padding: "10px 0px 0px 2%" },
            field: "state_id",
            grouping: false,
            render: (rowData) => rowData?.state_id?.state_name || "",
          },
          {
            title: "Region",
            headerStyle: { textAlign: "start", paddingLeft: "2%" },
            cellStyle: { textAlign: "start", padding: "10px 0px 0px 2%" },
            field: "professional_tax_region_id",
            grouping: false,
            render: (rowData) =>
              rowData?.professional_tax_region_id?.region_name || "",
          },
          {
            title: "Is Default",
            cellStyle: { padding: "0px 10px 0px 15px" },
            field: "is_default",
            render: (rowData) => (rowData?.is_default ? "Yes" : "No"),
          },
        ]}
        data={structureData || []}
        actions={[
          {
            icon: () => <AddIcon />,
            tooltip: "Add Work Location",
            isFreeAction: true,
            onClick: () => {
              setEditedRecord(null);
              setOpenPopup(true);
            },
          },
          {
            icon: () => <EditIcon sx={{ color: "#637381" }} />,
            tooltip: "Edit",
            onClick: (event, rowData) => {
              setEditedRecord(rowData);
              setOpenPopup(true);
            },
          },
          (rowData) => ({
            icon: () => <DeleteIcon sx={{ color: (rowData?.is_default || rowData?.is_utitlised) ? "#bdbdbd" : "#637381" }} />,
            tooltip: (rowData?.is_default && rowData?.is_utitlised) ? "This is a default location and is also mapped to employees"
                  : rowData?.is_default
                  ? "This is a default work location and cannot be deleted"
                  : rowData?.is_utitlised
                  ? "This location is mapped to employees and cannot be deleted"
                  : "Delete",
            onClick: (event, rowData) => setDeleteConfirm(rowData),
            disabled: rowData?.is_default || rowData?.is_utitlised
          })
        ]}
        options={{
          maxBodyHeight: 220,
          rowStyle: { fontSize: "13px" },
          headerStyle: { padding: "0px 10px", fontWeight: "bold" },
          sorting: true,
          search: false,
          searchFieldAlignment: "right",
          searchAutoFocus: true,
          searchFieldVariant: "standard",
          filtering: false,
          paging: false,
          selection: false,
          actionsColumnIndex: -1,
          grouping: false,
          addRowPosition: "first",
        }}
        title=""
      />
      <Popup
        fullWidth={true}
        maxWidth="sm"
        title={editedRecord ? "Edit Work Location" : "Add Work Location"}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <WorkGeoLocationConfig
          editedRecord={editedRecord}
          setOpenPopup={setOpenPopup}
        />
      </Popup>
      <ConfirmationDialog
        title={"Confirm Delete"}
        content={"Are you sure you want to delete this work location?"}
        openDialog={Boolean(deleteConfirm)}
        closeDialog={setDeleteConfirm}
        OkButtonText="Yes"
        onSubmit={() => {
              if (deleteConfirm) {
                dispatch(
                  DeleteWorkLocationAction({
                    ats_work_location_id: `{${deleteConfirm?.ats_work_location_id}}`,
                  })
                );
              }
              setDeleteConfirm(null);
            }}
      />
    </Box>
  );
};
export default WorkLocation;
